import { axios } from "../../../../../Global";
import React, { useState } from "react";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import { AiOutlineFilePdf } from "react-icons/ai";
import { SiMicrosoftexcel } from "react-icons/si";
import { Link } from "react-router-dom";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import { getObjectValue } from "../../../../../utils/functions";
import SettingsPopup from "../../../../../ReusableComponents/SettingsPopup/SettingsPopup";

export default function ListDataCostSheet({
  costDetails = [],
  costHeadings = [],
  list = [],
  editData,
  deleteData,
  loading,
  selectedFields = [],
  houtType,
}) {
  const dashboardData = useSelector((state) => state.dashboardData);

  const checkAccess = (module, name) => {
    return checkAccessFn(dashboardData, module, name);
  };

  const calculateTotalCost = (basicId) => {
    let totalCost = 0;
    const currentCostDetails = costDetails?.filter(
      (details) =>
        details?.quotation_cost_sheet_profession_basic_information_id == basicId
    );
    for (let currentCost of currentCostDetails) {
      totalCost = totalCost + Number(currentCost?.cost);
    }
    return Number(totalCost).toFixed(2);
  };

  const calculateSectionWiseCost = (basicId, rateCategoryId) => {
    let totalCost = 0;
    const currentCostDetails = costDetails?.filter(
      (details) =>
        details?.quotation_cost_sheet_profession_basic_information_id == basicId
    );

    const currentSectionHeadingsId = costHeadings
      ?.filter((heading) => heading?.rate_category_id == rateCategoryId)
      ?.map((heading) => heading?.id);

    currentSectionHeadingsId.map((headingId) => {
      currentCostDetails?.map((detail) => {
        if (headingId == detail?.quotation_cost_sheet_heading_id) {
          totalCost += Number(detail?.cost);
        }
      });
    });

    return Number(totalCost).toFixed(2);
  };

  const getDefaultAndDynamicValues = (basicId, title = "") => {
    const currentCostDetails = costDetails?.filter(
      (details) =>
        details?.quotation_cost_sheet_profession_basic_information_id == basicId
    );
    const currentHeading = costHeadings?.find(
      (details) =>
        details?.rate_category_item_name == title ||
        details?.rate_category_item?.name == title
    );
    const currentCost = currentCostDetails.find(
      (details) =>
        details?.quotation_cost_sheet_heading_id == currentHeading?.id
    );
    console.log(currentCost);
    return currentCost?.cost;
  };

  const getNormalizedValue = (data, selectedData) => {
    switch (selectedData?.type) {
      case "longDate":
        return String(
          data[selectedData.value] ||
            getObjectValue(data, selectedData.value) ||
            "-"
        ).split("T")[0];
      case "totalCost":
        return calculateTotalCost(data?.id);
      case "totalSectionCost":
        return calculateSectionWiseCost(data?.id, selectedData?.value);
      case "Default":
        return getDefaultAndDynamicValues(data?.id, selectedData?.title);
      case "Dynamic":
        return getDefaultAndDynamicValues(data?.id, selectedData?.title);
      default:
        return String(
          data[selectedData.value] ||
            getObjectValue(data, selectedData.value) ||
            "-"
        );
    }
  };

  return (
    <>
      <div className="p-5">
        <div
          className={`rounded-md overflow-x-scroll py-5 flex flex-col bg-white p-3`}
        >
          <div className="flex justify-between gap-5 min-w-full w-fit">
            <p className={`font-semibold w-full min-w-[4rem] max-w-[5rem]`}>
              Sl No.
            </p>
            {selectedFields.map((selectedData) => (
              <p
                key={selectedData.id}
                className={`font-semibold w-full ${selectedData.width}`}
              >
                {selectedData?.title}
              </p>
            ))}
            <p className={`font-semibold w-full min-w-fit max-w-[6rem]`}>
              Action
            </p>
          </div>
          {list.length <= 0 && <LoadingWithLable className="col-span-5" />}
          <div className="min-w-full w-fit  flex flex-col gap-y-3 mt-4">
            {list.map((data, index) => (
              <div key={index} className="flex flex-col gap-3">
                <div className="flex justify-between gap-5 min-w-full w-fit">
                  <p className=" w-full min-w-[4rem] max-w-[5rem]">
                    {index + 1}
                  </p>
                  {selectedFields.map((selectedData) => (
                    <p
                      className={`w-full ${selectedData.width}`}
                      key={selectedData?.id}
                    >
                      {getNormalizedValue(data, selectedData)}
                    </p>
                  ))}

                  <div className="flex items-start gap-2  w-full min-w-fit max-w-[6rem]">
                    {checkAccess("Quotation", "quotation-cost-sheet-edit") && (
                      <button
                        className="p-1 px-2 text-center rounded-md ring-1 ring-slate-600"
                        onClick={() => editData(data.id)}
                      >
                        <CiEdit size={"1.4rem"} />
                      </button>
                    )}

                    {checkAccess(
                      "Quotation",
                      "quotation-cost-sheet-delete"
                    ) && (
                      <button
                        className="p-1 px-2 rounded-md ring-1 ring-red text-white text-center bg-red"
                        onClick={() =>
                          deleteData((oldState) => ({
                            open: true,
                            id: data.id,
                          }))
                        }
                        disabled={loading.delete}
                      >
                        {loading.delete && loading.loadingId === data.id ? (
                          <CgSpinner className="animate-spin mx-auto" />
                        ) : (
                          <MdDeleteOutline size={"1.4rem"} />
                        )}
                      </button>
                    )}
                  </div>
                </div>
                <hr className="border-[1.5px] border-slate-100  min-w-full" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
